import React from 'react';
import PageCardItemModel from '../Types/PageCardItemModel';
import ResponsiveImage from '../Components/ResponsiveImage/ResponsiveImage';
import clsx from 'clsx';
import Tag from '../Components/Tag/Tag';

interface PageCardItemProps {
  item: PageCardItemModel;
  aspectRatio?: string;
  className?: string;
}

const getTagColor = (color: string) => {
  if (color && color.length == 7) return color + 'E6';
  return color;
};

const PageCardItem = ({
  item,
  aspectRatio,
  className,
}: PageCardItemProps) => {
  return (
    <div
      className={clsx('fade-slide-up relative flex flex-col', className)}
    >
      {item.tags && item.tags.length > 0 && (
        <div className="absolute left-2 top-2 z-10 flex flex-col items-start gap-2 md:flex-row">
          {item.tags.map((tag, idx) => (
            <Tag tagSize="small" key={tag.id} {...tag}>
              {tag.name}
            </Tag>
          ))}
        </div>
      )}
      <a className="group" href={item.url}>
        <div className="mb-4">
          {item.thumbnail?.sizeDefinitions &&
          item.thumbnail.sizeDefinitions.length > 0 ? (
            <div className="overflow-hidden rounded will-change-transform">
              <ResponsiveImage
                {...item.thumbnail}
                lazyLoad={true}
                imgProps={{
                  className: clsx(
                    'h-full w-full rounded object-cover transition duration-500 group-hover:scale-105',
                    aspectRatio
                  ),
                }}
              />
            </div>
          ) : (
            <div
              className={clsx(
                'mb-4 h-full w-full rounded bg-gray-100',
                aspectRatio
              )}
            ></div>
          )}
        </div>
        <div className="flex flex-col items-start px-1">
          <h4 className="mb-1 inline-block font-normal text-gray-700 transition group-hover:text-gray-500">
            {item.title}
          </h4>
          <p
            style={{
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
            }}
            className="block max-h-[3em] overflow-hidden text-ellipsis break-words text-lg leading-[1.5em] text-gray-700 group-hover:text-gray-500"
          >
            {item.textExcerpt}
          </p>
        </div>
      </a>
    </div>
  );
};

export default PageCardItem;
